class AppModel {
  constructor() {
    this.lat = 0;
    this.lng = 0;
    this.listItems = [];
  }

  getLat() {
    return this.lat;
  }

  getLng() {
    return this.lng;
  }

  getListItems() {
    return this.listItems;
  }

  setLat(lat) {
    this.lat = lat;
  }

  setLng(lng) {
    this.lng = lng;
  }

  setListItems(listItems) {
    this.listItems = listItems;
  }

}

export {AppModel};